import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import BasicBackground from '../BasicBackground';
import { globalStyles as styles } from '../style/gstheme';
import PrimaryButton from '../PrimaryButton';

class TooLate extends Component {

  tryAgain = () => {
    this.props.history.push("/signup");
  };

  render() {

    const { classes } = this.props;
    return (
      <BasicBackground>
        <div style={{ width: '100%', position: 'absolute', top: 100, textAlign: 'center' }}>
          <Typography className={classes.mainHeadingLight}>Registration Confirmation Lapsed</Typography>
          <PrimaryButton onClick={this.tryAgain}>Try Registering Again</PrimaryButton>
        </div>
      </BasicBackground>
    );
  }
}


export default withRouter(withStyles(styles)(TooLate));